import { writable } from 'svelte/store'

// True from module load until the router actually applies a route component,
// so the auth guard / OAuth callback round-trips never leave a blank screen.
export const authChecking = writable<boolean>(true)
